import { type ConditionExpr, parseConditionalTemplate } from "./conditional";

/**
 * Pure helpers for a conditional table row's bare condition. A row stores only the
 * boolean expression that went inside `{{#if …}}` (the row itself is the body), so
 * to reuse the conditional node's parser/editor we wrap it back into a one-branch
 * `{{#if}}` template and pull the single condition out.
 */

/** Wrap a bare row condition into a body-less `{{#if}}` template. */
export const wrapRowCondition = (condition: string): string =>
  `{{#if ${condition}}}{{/if}}`;

/**
 * Parse a row's bare condition into the structured `ConditionExpr` that
 * `ConditionEditor` edits. Anything we can't model (and/or, nested helpers, an
 * empty string) falls back to a raw expression, which the editor exposes as a
 * free-text field — so a row's condition is never uneditable.
 */
export const parseRowCondition = (condition: string): ConditionExpr =>
  parseConditionalTemplate(wrapRowCondition(condition)).branches[0]?.condition ?? {
    kind: "raw",
    expression: condition,
  };
